import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import PDFToExcelUploadVie from "./PDFToExcelUploadView";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PDFToExcelMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF To Excel (.xls, .xlsx) Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_to_excel", title: "Convert PDF To Excel Online" },
    data2: { link: "/pdf_to_excel", title: "PDF To Spreadsheet Converter" },
    data3: { link: "/pdf_to_excel", title: "PDF To XLSX Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to Excel online instantly. Turn PDF tables into editable spreadsheets quickly with our fast, secure PDF to Excel converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf to excel, convert pdf to excel, pdf to xls, pdf to xlsx, online pdf to excel, pdf spreadsheet converter, extract tables from pdf, pdf to excel online, pdf data to excel, pdf table extractor, pdf excel converter, editable excel from pdf, pdf document to excel, pdf to spreadsheet, pdf conversion tool, pdf to xls online, pdf to xlsx online, pdf to xls converter free, pdf xlsx converter free, pdf converter, pdf converter online, pdf to excel online free,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <PDFToExcelUploadVie
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["pdf"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF to Excel converter online website is a powerful and efficient solution for converting PDF documents into fully editable Excel spreadsheets with high accuracy. Designed to extract tables, rows, columns, and numerical data from PDF files, this advanced PDF to Excel online converter transforms static PDFs into Excel formats such as XLS and XLSX while preserving the original data structure as closely as possible. Whether you are an accountant managing financial reports, a business analyst working with data sheets, or a student handling assignments, this convert PDF to Excel online tool simplifies data editing and analysis. With an easy upload and convert process, users can quickly turn PDF files into Excel spreadsheets directly from their browser—no software installation required. Our PDF to Excel converter online ensures clean, well organized output that can be easily sorted, filtered, and recalculated in Microsoft Excel or other spreadsheet applications. Strong security practices are implemented to protect your documents, with files processed safely and removed automatically after conversion. By converting PDFs into editable Excel files, this tool saves time, reduces manual data entry, and improves productivity. If you’re searching for a fast, accurate, and secure PDF to Excel online converter that delivers professional results for data driven tasks, this website is the ideal choice for modern document conversion needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF To Excel Converter"
          why_use={[
            {
              title: "Convert PDFs into Editable Excel Files",
              description:
                "Our PDF to Excel converter online allows you to transform static PDF documents into fully editable Excel spreadsheets, making it easy to update, analyze, and manage data efficiently.",
            },

            {
              title: "Save Time and Reduce Manual Data Entry",
              description:
                "Using a convert PDF to Excel online tool eliminates the need to manually copy tables and numbers from PDFs, helping save time and minimize errors.",
            },

            {
              title: "Preserve Table Structure and Data Accuracy",
              description:
                "Our reliable PDF to Excel online converter accurately extracts rows, columns, and tables while maintaining data integrity and original structure.",
            },

            {
              title: "Improve Productivity and Workflow Efficiency",
              description:
                "With a fast PDF to Excel converter online website, professionals can quickly convert reports and datasets, streamlining daily tasks and boosting productivity.",
            },

            {
              title: "No Software Installation Required",
              description:
                "Our browser based PDF to Excel online tool works without installing software, allowing users to convert PDF to Excel instantly from any device.",
            },

            {
              title: "Ideal for Business and Financial Documents",
              description:
                "This PDF to Excel online converter is essential for handling invoices, financial statements, sales reports, and accounting data that require calculations and editing.",
            },

            {
              title: "Easy Data Editing and Analysis",
              description:
                "Converting PDF to Excel online enables sorting, filtering, formulas, and data visualization in Excel, which is not possible with static PDF files.",
            },

            {
              title: "Supports Large and Complex PDF Files",
              description:
                "Our advanced PDF to Excel converter online can process multi page PDFs and complex tables accurately, making it suitable for professional use.",
            },

            {
              title: "Secure and Reliable Online Conversion",
              description:
                "This secure PDF to Excel online website ensures safe file handling and protects sensitive information during the conversion process.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "How do I convert PDF to Excel online?",
              description:
                "To convert PDF to Excel online, open the PDF to Excel tool on ShivaPDF.com, select your PDF file, start the conversion, and download the resulting Excel file when processing is complete. Review the converted spreadsheet to ensure the data is accurate.",
            },
            {
              title: "Can I convert PDF to Excel for free?",
              description:
                "An online PDF to Excel converter can help you turn PDF documents into spreadsheet files without installing desktop software. Check ShivaPDF's current tool page for free usage availability, file-size limits, and any conversion restrictions.",
            },
            {
              title: "How can I convert a PDF table to Excel?",
              description:
                "Upload a PDF containing a table to a PDF to Excel converter and run the conversion. The tool attempts to extract rows, columns, and cell values into a spreadsheet. Check the output for misplaced values or formatting changes.",
            },
            {
              title: "Can I convert PDF to XLSX?",
              description:
                "Yes, PDF to Excel converters that support XLSX output can convert PDF data into an Excel workbook. Check the available output formats in the tool before starting the conversion.",
            },
            {
              title: "What is the difference between PDF and Excel files?",
              description:
                "PDF files are designed to preserve a document's appearance across devices, while Excel files are designed for working with data in rows and columns. Converting PDF to Excel makes tabular information easier to edit, sort, calculate, and analyze.",
            },
            {
              title: "Can I convert PDF to Excel without losing formatting?",
              description:
                "Conversion tools try to preserve table structure and data, but the original layout may not be reproduced perfectly. Complex tables, merged cells, multiple columns, and unusual fonts can require manual adjustments after conversion.",
            },
            {
              title: "Can I convert a scanned PDF to Excel?",
              description:
                "Scanned PDFs contain page images rather than directly accessible text. Converting them to Excel generally requires optical character recognition (OCR) to identify the text and numbers before organizing the data into spreadsheet cells.",
            },
            {
              title: "Do I need OCR to convert PDF to Excel?",
              description:
                "OCR is usually needed when the PDF contains scanned pages or images of tables. Digitally generated PDFs may allow text and table extraction without OCR, depending on how the document was created and how the converter works.",
            },
            {
              title: "Can I convert PDF to Excel on Mac and Windows?",
              description:
                "A browser-based PDF to Excel converter can be used on macOS and Windows through a supported web browser. You generally do not need to install a separate desktop application to access an online tool.",
            },
            {
              title: "Can I convert PDF to Excel on an iPhone or Android phone?",
              description:
                "You may be able to convert PDF files to Excel using a mobile browser. The experience depends on the website's mobile support, your device's available memory, and the size and complexity of the PDF.",
            },
            {
              title: "Can I convert multiple PDF tables into Excel?",
              description:
                "A PDF converter may extract multiple tables from a document, depending on its capabilities and the document layout. Review the resulting workbook to check whether the tables appear on the correct sheets and in the intended order.",
            },
            {
              title: "Can I convert a multi-page PDF to Excel?",
              description:
                "Yes, a converter can process multi-page PDFs when supported. The resulting spreadsheet structure depends on how the tool organizes tables and data across pages, so verify that all required pages have been included.",
            },
            {
              title: "Can I convert bank statements from PDF to Excel?",
              description:
                "PDF to Excel conversion can help organize transaction tables from bank statements into spreadsheet rows and columns. Because financial data must be accurate, carefully verify dates, transaction descriptions, amounts, and balances after conversion.",
            },
            {
              title: "Can I convert invoices and financial reports to Excel?",
              description:
                "A PDF to Excel converter can help extract tabular data from invoices, financial reports, and similar documents. Results depend on the layout and whether the PDF contains selectable text or scanned images.",
            },
            {
              title: "Will formulas from a PDF work in Excel after conversion?",
              description:
                "PDF files generally store displayed content rather than the original spreadsheet formulas. A converter may extract visible values, but it usually cannot reconstruct the original formulas, calculations, or workbook logic reliably.",
            },
            {
              title: "Can I edit the Excel file after converting a PDF?",
              description:
                "Yes, once the data is converted into a supported Excel format, you can edit cells, organize rows, apply formulas, sort information, and create charts using compatible spreadsheet software.",
            },
            {
              title: "Why does my converted Excel file contain incorrect data?",
              description:
                "Conversion errors can occur because of low-quality scans, complex tables, merged cells, unusual fonts, or ambiguous number formats. Check the original PDF and correct any misplaced text, missing values, dates, or decimal points in the spreadsheet.",
            },
            {
              title: "Can I convert a password-protected PDF to Excel?",
              description:
                "A password-protected PDF may need to be unlocked before conversion. Only process documents you are authorized to access, and follow the tool's supported steps for protected files.",
            },
            {
              title: "Is it safe to convert PDF to Excel online?",
              description:
                "File privacy depends on how the conversion service processes and stores documents. Before converting confidential financial or business files, review the website's privacy policy and check whether files are uploaded, retained, or processed locally.",
            },
            {
              title: "Can I convert PDF to Excel without installing software?",
              description:
                "Yes, a web-based PDF to Excel converter lets you access the conversion tool through a browser without installing dedicated desktop software, provided your browser and device are supported.",
            },
            {
              title: "Can I convert PDF to Excel offline?",
              description:
                "Offline conversion is possible when the required conversion engine is available on your device. Many online PDF to Excel services require an internet connection, particularly when documents are processed on a remote server.",
            },
            {
              title: "What Excel formats can I get from a PDF converter?",
              description:
                "Available output formats depend on the converter. Common spreadsheet formats include XLSX and XLS, while some tools may offer CSV for tabular data. Check ShivaPDF's available download options for supported formats.",
            },
            {
              title: "Does converting PDF to Excel change the original PDF?",
              description:
                "The conversion process generally creates a separate spreadsheet and leaves the original PDF unchanged. Keep your original file if you need to preserve the source document or compare the extracted data.",
            },
            {
              title: "Why should I use ShivaPDF's PDF to Excel converter?",
              description:
                "A web-based PDF to Excel tool can help you turn PDF tables into editable spreadsheet data for analysis, reporting, and record keeping. Check ShivaPDF's tool page for its current conversion features, supported formats, file limits, and privacy details.",
            },
          ]} />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFToExcelMain;
